<div [ngClass]="{'subscription-input': true, 'wide': showWide}" [hidden]="!showEdit">
    <mat-form-field>
        <input matInput placeholder="{{ placeholder }}" [formControl]="subscriptionEmails" [matTooltip]="dictionary.tooltip.addSubscribers">
    </mat-form-field>
    <button type="button" mat-raised-button color="primary" (click)="addSubscriptions();" [disabled]="!showEdit">Add Subscribers</button>
</div>
<div class="subscribers">
    <div class subscriber-list>
        <div *ngFor="let subscriber of subscriptions; let i=index" [ngClass]="{'single-subscriber': true, 'compact': !showWide}">
            <div class="subscriber-icon" style="width: 50px;">
                <mat-icon>person</mat-icon>
            </div>
            <div class="info">
                <h4 class="email">{{ subscriber }}</h4>
            </div>
            <div [ngClass]="showEdit ? 'delete' : 'hide'" (click)="removeSubscription(i)">
                <mat-icon class="centered" color="primary" >delete</mat-icon>
            </div>
        </div>
    </div>
</div>
